import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { MainComponent } from './main/main.component';
import { ProcessesComponent } from './main/processes/processes.component';
import { ProcessComponent } from './main/processes/process/process.component';
import { ScopeComponent } from './main/processes/scope/scope.component';
import { AuthGuardService } from './service/auth-guard.service';
import { DashboardComponent } from './main/dashboard/dashboard.component';
import { TypeProcessComponent } from './main/processes/type-process/type-process.component';
import { UsersComponent } from './main/users/users.component';
import { LoginHistoryComponent } from './main/login-history/login-history.component';
import { AuthGuardAdminService } from './service/auth-guard-admin.service';
import { CreatePasswordComponent } from './create-password/create-password.component';
import { RecoverPasswordComponent } from './recover-password/recover-password.component';
import { TemplateComponent } from './print/template/template.component';
import { AuthCallbackComponent } from './auth/auth-callback.component';

const appRoutes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'create-password', component: CreatePasswordComponent },
  { path: 'recover-password', component: RecoverPasswordComponent },
  { path: 'azure-auth-callback', component: AuthCallbackComponent },
  { path: '', component: MainComponent, children: [
    { path: 'users', component: UsersComponent, canActivate: [AuthGuardAdminService] },
    { path: 'login-history', component: LoginHistoryComponent, canActivate: [AuthGuardAdminService] },
    { path: 'processes', component: ProcessesComponent, canActivate: [AuthGuardAdminService] },
    { path: 'processes/policy/:policyId', component: ProcessesComponent, canActivate: [AuthGuardService] },
    { path: 'processes/type/:typeId', component: ProcessesComponent, canActivate: [AuthGuardService] },
    { path: 'processes/process/:mode', component: ProcessComponent, canActivate: [AuthGuardService]},
    { path: 'processes/process/:mode/:policy', component: ProcessComponent, canActivate: [AuthGuardService]},
    { path: 'processes/process/:mode/:policy/:process', component: ProcessComponent, canActivate: [AuthGuardService]},
    { path: 'processes/scope/:mode/:policy', component: ScopeComponent, canActivate: [AuthGuardService]},
    { path: 'processes/scope/:mode/:policy/:process', component: ScopeComponent, canActivate: [AuthGuardService]},
    { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuardService] },
    { path: 'processes/typeProcess', component: TypeProcessComponent, canActivate: [AuthGuardService] },
    { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
  ], canActivate: [AuthGuardService] },
    { path: 'print', component: TemplateComponent},
  { path: '**', redirectTo: '', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { 
    scrollPositionRestoration: 'top',
    useHash: true 
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {

}